import clsx from "clsx";
import { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { checkIfClient } from "shared/lib/helpers";
import { useRouter } from "next/router";

export const Pagination = ({
  onChange = () => {},
  total = 0,
  current: _current,
  baseHref = "/",
  className,
}: {
  baseHref: string;
  total: number;
  onChange?: (selected: number) => void;
  current?: number;
  className?: string;
}) => {
  const { push } = useRouter();
  const [current, setCurrent] = useState(_current);

  useEffect(() => {
    setCurrent(_current);
  }, [_current]);

  const onChangeHandler = ({ selected }: { selected: number }) => {
    const page = selected + 1;

    onChange(selected);

    if (checkIfClient()) {
      push(
        page >= 1 && page <= total ? `${baseHref}/${page}` : "#",
        undefined,
        {
          scroll: false,
        }
      );
    }
  };

  return total > 1 ? (
    <div className={clsx(className)}>
      <ReactPaginate
        hrefAllControls
        forcePage={current || 0}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        hrefBuilder={(page, pageCount, selected) =>
          page >= 1 && page <= pageCount ? `${baseHref}/${page}` : "#"
        }
        //--------MORE-CONFIGS--------------
        breakLabel="..."
        nextLabel="Next"
        onPageChange={onChangeHandler}
        pageRangeDisplayed={1}
        marginPagesDisplayed={2}
        pageCount={total}
        previousLabel="Previous"
        renderOnZeroPageCount={() => null}
        //---------STYLES-------------
        containerClassName="flex items-center"
        pageClassName=""
        pageLinkClassName="p-2 m-2 mo:p-1"
        previousClassName={clsx("mr-4", {
          "opacity-0": current === 0,
        })}
        previousLinkClassName=""
        nextClassName={clsx("pointer-events-auto ml-4", {
          "opacity-0": current === total - 1,
        })}
        nextLinkClassName=""
        activeClassName="font-bold"
      />
    </div>
  ) : null;
};
